import {
  LOGOUT,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  TOKEN_EXPIRED,
  INVALID_CREDENTIALS,
  AUTH_ERROR,
  REDIRECT,
  SET_LOADING,
  RENEW_TOKEN
} from '../types';
import checkPrivilege from '../../utils/checkPrivilege';

export default (state, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      sessionStorage.setItem('token', action.payload.token);
      sessionStorage.setItem('refreshtoken', action.payload.refreshtoken);
      sessionStorage.setItem('userid', action.payload.user);
      return {
        ...state,
        token: action.payload.token,
        refreshToken: action.payload.refreshtoken,
        userid: action.payload.user,
        isAuthenticated: true,
        privilege: checkPrivilege(action.payload.token),
        loading: false
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    case RENEW_TOKEN:
      sessionStorage.setItem('token', action.payload.token);
      return {
        ...state,
        token: action.payload.token
      };
    case INVALID_CREDENTIALS:
    case TOKEN_EXPIRED:
    case LOGIN_FAIL:
    case LOGOUT:
    case REDIRECT:
    case AUTH_ERROR:
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshtoken');
      sessionStorage.removeItem('userid');
      return {
        ...state,
        token: null,
        refreshToken: null,
        isAuthenticated: null,
        loading: false,
        userid: null
      };
    default:
      return state;
  }
};
